document.addEventListener('click', function (event) {

	// If the clicked element doesn't have the right selector, bail
	if (!event.target.classList.contains('expand')) return;

	let target = event.target.dataset.target ? document.getElementById(event.target.dataset.target) : false;

	if(target) {

		expand_tile(target);
	}

}, false);

export default function expand_tile(target) {

	let tile_container = target.parentNode;
	let tiles = document.getElementById('tiles');

	if(tile_container) {

		//if this is already expanded, we need to shrink it
		if(target.classList.contains('expanded')) {
			target.classList.remove('absolute');
			target.classList.remove('expanded');

			let shrink_height = target.offsetHeight + 'px';
			let shrink_width = target.offsetWidth + 'px';

			target.classList.add('expanded');
			target.style.height = target.offsetHeight + 'px';
			target.style.width = target.offsetWidth + 'px';

			tiles.classList.remove('open');

			target.classList.add('absolute');
			target.classList.remove('expanded');

			target.style.height = shrink_height;
			target.style.width = shrink_width;
			
			setTimeout(function() {
				tile_container.style.height = '';
				target.classList.remove('absolute');
				target.classList.remove('tile-animatable');
				target.removeAttribute("style");
			}, 600);
		} else {
			//set the time container height to preserve the grid
			tile_container.style.height = tile_container.offsetHeight + 'px';

			//set a fixed width and height on the target container
			target.style.height = target.offsetHeight + 'px';
			target.style.width = target.offsetWidth + 'px';

			target.classList.add('absolute');
			target.classList.add('tile-animatable');

			tiles.classList.add('open');

			setTimeout(function() {
				target.classList.add('z-10');

				target.style.height = tiles.offsetHeight + 'px';
				target.style.width = tiles.offsetWidth + 'px';

				window.scrollTo({top: 0, behavior: 'smooth'});

				setTimeout(function() {
					target.style.height = '';
					target.style.width = '';
					target.classList.add('expanded');
				}, 600);
			}, 10);
		}		
	}

}